import { Tag } from "antd"
import PropTypes from "prop-types"
import { colors } from "themes/variables"

const selectedColor = {
  "Booking Request": colors.warning,
  Upcoming: colors.sportsmanBrand,
  Canceled: colors.error,
  Completed: colors.success,
  Paid: colors.success,
  "Payment Outstanding": colors.warning,
  "Partially Refunded": colors.warning,
  Refunded: colors.sportsmanBrand,
  Failed: colors.error,
  failed: colors.error, // will update soon lower and upper 
  pending: colors.warning,
  processing: colors.sportsmanBrand,
  partial_completed: colors.warning,
  skipped_failed: colors.warning,
  completed: colors.success
}

const StatusTag = ({ status, statusMessage }) => {
  return (
    <Tag
      title={status}
      className={`px-s mr-0 py-xxs border-0`}
      style={{
        maxWidth: "fit-content",
        color: selectedColor[status],
        backgroundColor: selectedColor[status] + "26"
      }}
    >
      {statusMessage ?? status}
    </Tag>
  )
}

StatusTag.propTypes = {
  status: PropTypes.string,
  statusMessage: PropTypes.string
}

export default StatusTag
